import PropTypes from 'prop-types';
import React from 'react';

export const ButtonWithIconAndWithTooltip = (props) => {
  return (
    <>
      {props.showButton && (
        <div className="tooltip-button">
          <span>{props.textTooltip}</span>
          <div className="header__link">
            <button
              id={props.htmlId}
              onClick={props.actionButton}
              disabled={props.disabledButton}
            >
              <img src={props.IconButton} alt={props.textImageAlt} />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

ButtonWithIconAndWithTooltip.propTypes = {
  showButton: PropTypes.bool,
  actionButton: PropTypes.func,
  IconButton: PropTypes.string,
  textTooltip: PropTypes.string,
  disabledButton: PropTypes.string,
  textImageAlt: PropTypes.string,
  htmlId: PropTypes.string
};
